import { gql } from 'graphql-request';
import { createQuery } from '@fivehealth/botero';

const GRAPHQL_DOCUMENT = gql`
  mutation cleoSubmissionLastSeenUpdate(
    $input: CleoSubmissionLastSeenUpdateInput!
  ) {
    cleoSubmissionLastSeenUpdate(input: $input) {
      lastSeenOn
    }
  }
`;

export default createQuery({
  gqlDocument: GRAPHQL_DOCUMENT,
  queryType: 'mutation',
  baseQueryKey: 'commentsSeen',
  keepPreviousData: true,
});
